<template>
  <div>
    <div class="dashboard-stat primary" style="padding: 25px 10px;" @click.stop="handleClick">
      <div class="fav-star-icon" @click.stop="handleClick">
        <star-icon class="isFavorite icon-size-xl"  :id="key" v-if="isFavorite"></star-icon>
        <star-outline-icon class="isNotFavorite icon-size-xl" :id="key" v-else></star-outline-icon>
      </div>
      <div class="details">
        <span v-if="hasLogo">
            <img :src="logo" class="logo">
        </span>
        <span v-if="!hasLogo">
            <home-alert-icon v-if="isHomeAlertIcon" class="icon"></home-alert-icon>
            <tag-icon v-if="isLabelIcon" class="icon"></tag-icon>
            <account-icon v-if="isCustomerCategory" class="icon"></account-icon>
            <home-icon v-if="isMortgageCategory" class="icon"></home-icon>
            <bullhorn-icon v-if="isDamageCategory" class="icon"></bullhorn-icon>
            <umbrella-icon v-if="isPolicyCategory" class="icon"></umbrella-icon>
            <email-icon v-if="isEmailCategory" class="icon"></email-icon>
            <message-icon v-if="isAfdMessageCategory" class="icon"></message-icon>
        </span>
        <span class="count">
            {{ count }}
        </span>
        <div class="content" style="margin: 0;" :title="name">
          {{ name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import staticSearchApi from '~/api/staticSearch';

export default {
  name: "StaticSearchComponent",
  props: {
    staticSearch: {
      required: true,
      type: Object
    },
    userId: {
      required: true,
      type: [Number, String]
    }
  },
  computed: {
    key() {
      return this.staticSearch.key;
    },
    isFavorite() {
      return this.staticSearch.is_favorite;
    },
    name() {
      return this.staticSearch.name;
    },
    description() {
      return this.staticSearch.description;
    },
    category() {
      return this.staticSearch.category;
    },
    count() {
      return this.staticSearch.count;
    },
    icon() {
      return this.staticSearch.icon;
    },
    hasIcon() {
      return this.staticSearch.has_icon;
    },
    logo() {
      return this.staticSearch.logo;
    },
    hasLogo() {
      return this.staticSearch.has_logo;
    },
    isCustomerCategory() {
      return (this.staticSearch.model === 'customer') && !this.hasIcon;
    },
    isDamageCategory() {
      return (this.staticSearch.model === 'damage') && !this.hasIcon;
    },
    isEmailCategory() {
      return (this.staticSearch.model === 'email') && !this.hasIcon;
    },
    isPolicyCategory() {
      return (this.staticSearch.model === 'policy') && !this.hasIcon;
    },
    isAfdMessageCategory() {
      return (this.staticSearch.model === 'afd_message') && !this.hasIcon;
    },
    isMortgageCategory() {
      return (this.staticSearch.model === 'mortgage') && !this.hasIcon;
    },
    isLabelIcon() {
      return this.icon === 'tag';
    },
    isHomeAlertIcon() {
      return this.icon === 'home-alert';
    }
  },

  methods: {
    click() {
      window.location = this.staticSearch.route;
    },
    handleClick(e) {
      if (!e.target.classList.contains('isNotFavorite') && !e.target.classList.contains('isFavorite')) {
        window.location = this.staticSearch.route;
      } else if (e.target.classList.contains('isNotFavorite')) {
        staticSearchApi.setFavorite(e.target.id, this.userId).then((data) => {
          this.staticSearch.is_favorite = true;
        })
      } else if (e.target.classList.contains('isFavorite')) {
        staticSearchApi.unsetFavorite(e.target.id, this.userId).then((data) => {
          this.staticSearch.is_favorite = false;
        })
      }
    }
  }
}
</script>

<style scoped>
.details .icon {
  font-size: 30px;
}

.details .count {
  font-size: 20px;
  vertical-align: bottom;
}

.fav-star-icon {
  position: absolute;
  top: 12px;
  right: 12px;

}

.fav-star-icon span svg {
  height: 1.5em;
  width: 1.5em;
  pointer-events: none;
}
</style>
